export const Spinner = {
  baseStyle: {
    color: 'gray.500',
  },

  defaultProps: {
    size: 'xl',
  },
};
